/* eslint-disable react-hooks/exhaustive-deps */
import { BigNumber, ethers } from "ethers";
import { useEffect } from "react";

import { SalesInfo, SaleType } from "../../constants/sale";
import { useGnarlyGoatsContractsState } from "../../hooks/useGnarlyGoatsContracts";
import { useMintGoats } from "../../hooks/useMintGoats";
import {
  Button,
  DashboardWrapper,
  Emoji,
  Interface,
  SelectorButton,
  SelectorInterface,
  Text,
  Title
} from "../../theme/components";
import GasEstimatesDashboard from "../GasEstimatesDashboard";

const MintDashboard = (props: any) => {
	const {
		circSupplyOfGoats,
		mintPassesClaimed,
		mintPassesAvailable,
		accountMintPassBalance,
		fetchAccountMintPassBalance,
	} = useGnarlyGoatsContractsState()

	const {
		mint,
		mintType,
		setMintType,
		mintAmount,
		setMintAmount,
		gasEstimatesMap,
		gasEstimateLevel,
		setGasEstimateLevel,
	} = useMintGoats()

	useEffect(() => {
		setMintAmount(1)
	}, [mintType])

	const DisplaySaleTypeSelector = () => {
		return (
			<>
				<SelectorInterface>
					{Object.values(SaleType).map((_saleType: string) => {
						return SalesInfo[_saleType].isActive ? (
							<SelectorButton
								key={_saleType}
								selected={_saleType === mintType}
								onClick={() => {
									if (_saleType !== mintType) {
										setMintType(_saleType as SaleType)
									}
								}}>
								<Text>{_saleType}</Text>
							</SelectorButton>
						) : (
							<div key={_saleType}></div>
						)
					})}
				</SelectorInterface>
			</>
		)
	}

	/**
	 * @returns the sale information for the selected mint type
	 */
	const DisplaySaleInfo = () => {
		let goatPriceContent: string | undefined = undefined

		if (SalesInfo[mintType].tokenPriceInEth !== undefined) {
			goatPriceContent = `Price: ${ethers.constants.EtherSymbol} ${
				SalesInfo[mintType].tokenPriceInEth as number
			}`
		}

		var remaining = undefined,
			available = undefined

		switch (mintType) {
			case SaleType.ClaimMintPasses:
				available = `Available: ${mintPassesAvailable}`
				remaining = `Remaining: ${(
					SalesInfo[mintType].totalSupply - mintPassesClaimed
				).toLocaleString()}`
				break

			case SaleType.ClaimWhitelistGoats:
				let _r = SalesInfo[mintType].totalSupply - circSupplyOfGoats
				remaining = `Remaining: ${_r < 0 ? 0 : _r.toLocaleString()}`
				break

			case SaleType.MintGoats:
				console.log(SalesInfo[mintType].totalSupply, circSupplyOfGoats)
				remaining = `Remaining: ${(
					SalesInfo[mintType].totalSupply - circSupplyOfGoats
				).toLocaleString()}`
				break
		}

		var totalSupply: string = `Total: ${SalesInfo[
			mintType
		].totalSupply.toLocaleString()}`

		return (
			<div>
				<Title>{SalesInfo[mintType].description}</Title>
				<Interface justifyContent={'space-between'}>
					{!!goatPriceContent && (
						<Text key={`price`} color2>
							{goatPriceContent}
						</Text>
					)}
					{!!available && (
						<Text key={`amount-available`} color2>
							{available}
						</Text>
					)}
					{!!remaining && (
						<Text key={`amount-remaining`} color2>
							{remaining}
						</Text>
					)}
					{!!SalesInfo[mintType].tokenPriceInEth && (
						<Text key={`total-supply`} color2>
							{totalSupply}
						</Text>
					)}
				</Interface>
			</div>
		)
	}

	const DisplayMintInterface = () => {
		let _totalPrice = Number(
			mintAmount * (SalesInfo[mintType].tokenPriceInEth as number)
		)

		let _totalPriceString: string = _totalPrice.toFixed(3)

		if (mintType === SaleType.MintGoats) {
			_totalPriceString = _totalPrice.toFixed(2)
		}

		return (
			<>
				{!!SalesInfo[mintType].tokenPriceInEth && (
					<Text
						color1>{`Total Price: ${ethers.constants.EtherSymbol} ${_totalPriceString}`}</Text>
				)}

				<Interface>
					<Button
						onClick={async () => {
							let isSuccess = await mint(BigNumber.from(mintAmount))
							if (isSuccess) {
								// console.log('Updating account mint pass balance')
								await fetchAccountMintPassBalance()
							}
						}}>
						Submit Transaction
					</Button>
				</Interface>

				<GasEstimatesDashboard
					gasEstimatesMap={gasEstimatesMap}
					setGasEstimateLevel={setGasEstimateLevel}
					selectedGasEstimateLevel={gasEstimateLevel}
					mintAmount={mintAmount}
					toggleMintAmount={setMintAmount}
					saleType={mintType}></GasEstimatesDashboard>
			</>
		)
	}

	return (
		<DashboardWrapper noTheme>
			{DisplaySaleTypeSelector()}

			<br />
			<br />
			<br />

			{DisplaySaleInfo()}

			{DisplayMintInterface()}
		</DashboardWrapper>
	)
}

export default MintDashboard
